export const COLOURS = {
  bg: "#0f172a",
  text: "#cbd5e1",
  textStrong: "#f1f5f9",
  textMuted: "#94a3b8",
  blue: "#2563eb",
  blueDark: "#1e40af",
  white: "#ffffff",
  accent: "#5227ff",
  black: "#000000",
};

export const LAYOUT = {
  frameWidth: 960,
  frameMargin: 40,
  framePadding: 60,
};
